/* eslint-disable jira/filename-case */
export const USER_ROLE = {
	END_USER: 'end-user',
	SITE_ADMIN: 'site-admin',
	JIRA_ADMIN: 'jira-admin',
} as const;
